/**
 * LayoutsPanel component
 * @constructor editor.mediatabs.LayoutsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.book.edition", class LayoutsPanel extends fx.components.Box
{
    
    constructor(model)
	{
		super(model);

		this.layouts = model.layouts;
        this._book = model.creation;

		this.listenUpdates(model.creation);
		
	}

	get filterChoices()
	{
		if (!this._filterChoices)
			this._filterChoices = [	{label:fx.text("Thématique"), data:"recommended"},  {label:fx.text("Classique"), data:"classical"}];
								
		if (this.layouts.hasCustomLayouts() && !this._filterChoices.find({data:"custom"}))
			this._filterChoices.push( {label:fx.text("Sauvegardé"), data:"custom"} );

		return this._filterChoices;
	}

	set filterChoices(choices)
	{
		this._filterChoices = choices;
		if(this.numberPhotoSelect)
			this._selectTab(this._filterChoices[0].data);
	}

	get book()
	{
		return this._book;
	}

	set book(val)
	{
		this._book = val;
	}
	
	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		this._currentArea = val;

		if (this.layoutFilter)
			this.layoutFilter.area = this._currentArea;

		this._showGrid();
	}

	create()
	{
		super.create();

		//--------------------- covers ---------------------//

		this.coversPanel = new fx.components.Box("covers");
		this.coversPanel.effect = "fade";

		let maxRowHeight, containerWidth;
		switch(this.book.shape_option)
        {
            case "square":
                maxRowHeight = 260;
				containerWidth = 210;
                break;
            case "landscape":
                maxRowHeight = 200;
				containerWidth = 210;
                break;
            case "portrait":
                maxRowHeight = 280;
				containerWidth = 168;
                break;
        }

		this.themeCoverFilter = new filters.ThemeCoverFilter( this.data.theme.theme_tag_id, this.data.themes);
		

		this.coveNumberPhotoSelect = new fx.components.SelectButtons({items : [	{label:"1", value:1}, 
											{label:"2", value:2}, 
											{label:"3", value:3}, 
											{label:"4", value:4}, 
											{label:"5+", value:"+"} ]});

		this.coversGrid = new fx.components.VerticalGridDynamic( {  className : "coversGrid",
																	data : this.data,
																	filter : this.themeCoverFilter,
																	sharedData : this.book,
																	maxElementsPerRow : 1,
																	maxRowHeight : maxRowHeight,
																	newChildEffect : "fade",
																	containerWidth : containerWidth,
																	containerLeft : "center",
																	marginBottom : 60,
																	renderers : {Theme : shared.renderers.FrontCoverRenderer, ThemeLayout : shared.renderers.LayoutRenderer} 
																} );
		
		this.coverChoicesSelect = new fx.components.TabBarHorizontal( {tabs : this.filterChoices, style : "underline"} );
		
		

		this.coverClassicBox = new fx.components.Box("classicBox");
		this.coverClassicBox.addChild(this.coveNumberPhotoSelect, {width:"210", height: 50, top : 0, right: 5});
		this.coverClassicBox.addChild( new fx.components.Text({className : "label", text : fx.text("Nombre de photos")}), {height : 20, top : 15, left : 7});
		this.coverClassicBox.visibleAtStart = false;
		this.coverClassicBox.effect = "vslide";

		this.coversPanel.addChild(this.coverChoicesSelect, {width:"100%", height: 40, top : 55, left: 5});
		this.coversPanel.addChild(this.coverClassicBox, {width:"100%", top : 110, left: 0});
		this.coversPanel.addChild(this.coversGrid, {height:"fill", width:"100%", top : 115});
		this.coversPanel.addChild( new fx.components.Text({className : "coverTitle", text : fx.text("Couvertures pour votre album")}), {width : "100%",height : 20, top : 20, left : 0});
		//this.coversPanel.addChild( new fx.components.Text({className : "coverSubtitle", text : fx.text("Choisissez la couverture de votre album")}), {width : "100%",height : 50, top : 50, left : 0});
		this.addChild(this.coversPanel, {width: "100%", height: "100%"});


		//--------------------- layouts ---------------------//

		this.layoutFilter = new filters.LayoutThemeFilter( this.data.theme.id, this.data.theme.theme_tag_id, this.data.themes, "recommended" );
		

		this.choicesSelect = new fx.components.TabBarHorizontal( {tabs : this.filterChoices, style : "underline"} );
	
		this.numberPhotoSelect = new fx.components.SelectButtons({items : [	{label:"1", value:1}, 
																	{label:"2", value:2}, 
																	{label:"3", value:3}, 
																	{label:"4", value:4}, 
																	{label:"5+", value:"+"} ]});
		switch(this.book.shape_option)
        {
            case "square":
                maxRowHeight = 160;
				break;
            case "landscape":
                maxRowHeight = 160;
				break;
            case "portrait":
                maxRowHeight = 200;
				break;
        }

		this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
																	data : this.layouts,
																	filter : this.layoutFilter,
																	maxElementsPerRow : 2,
																	maxRowHeight : 230,
																	newChildEffect : "fade",
																	renderers : {ThemeLayout : shared.renderers.LayoutRenderer} 
																} );

		this.layoutsPanel = new fx.components.Box("layouts");
		this.layoutsPanel.effect = "fade";

		this.layoutsPanel.addChild(this.choicesSelect, {width:"100%", height: 40, top : 55, left: 5});

		this.classicBox = new fx.components.Box("classicBox");
		this.classicBox.addChild(this.numberPhotoSelect, {width:"210", height: 50, top : 0, right: 5});
		this.classicBox.addChild( new fx.components.Text({className : "label", text : fx.text("Nombre de photos")}), {height : 20, top : 15, left : 7});
		this.classicBox.visibleAtStart = false;
		this.classicBox.effect = "vslide";
		this.layoutsPanel.addChild(this.classicBox, {width:"100%", top : 110, left: 0});

		this.layoutsPanel.addChild(this.layoutsGrid, {height:"fill", width:"100%", top : 115});

		this.layoutsPanel.addChild( new fx.components.Text({className : "coverTitle", text : fx.text("Modèles pour vos pages")}), {width : "100%",height : 20, top : 20, left : 0});

		this.layoutsPanel.visibleAtStart = false;
		this.layoutsPanel.effect = "hslidein";
		this.addChild(this.layoutsPanel, {width: "100%", height: "100%"});

	}

	/****** Events ******/

	onReady()
	{
		super.onReady();

		this.on("click", this.onClick, this.coversGrid);

		this.on("more", this.onMore, this.layoutsGrid);
		this.on("changed", this.onCoverTabsChanged, this.coveNumberPhotoSelect);
		this.on("changed", this.onTabsChanged, this.numberPhotoSelect);
		
		this.on("tabchanged", this.onCoverChoiceChanged, this.coverChoicesSelect);
		this.on("tabchanged", this.onChoiceChanged, this.choicesSelect);

        this.on("updated", this.onZoomChanged, this.data.zoom);


		// edition
		if (this.data.theme)
		{
			this.loading(true, fx.text("Chargement"))
			this.data.themes.load(this.data.theme.theme_tag_id, true);
		}

		this._showGrid();
		this._selectTab(this._filterChoices[0].data);

	}

    onZoomChanged()
    {
        this._showGrid();
    }

	onClick(e)
	{
		if (fx.dom.parent(e.target, ".DefaultRenderer"))
			this.data.event("change-thematics");
	}

	onCoverTabsChanged()
	{
		this.themeCoverFilter.search = this.coveNumberPhotoSelect.selectedItem.value;
	}

	onTabsChanged()
	{
		this.layoutFilter.search = this.numberPhotoSelect.selectedItem.value;
	}

	onCoverChoiceChanged(event)
	{
		if (!this.coverChoicesSelect.selectedItem) return;

		this.coversGrid.scrollTop();

		switch(this.coverChoicesSelect.selectedItem.data)
		{
			case "recommended":
				this.themeCoverFilter.search = "themes";
				this.coverClassicBox.hide();
				this.coversGrid.top(115);
				break;
			case "classical":
				this.themeCoverFilter.search = this.coveNumberPhotoSelect.selectedItem.value;
				this.coverClassicBox.show();
				this.coversGrid.top(175);
				break;
			case "custom":
				this.themeCoverFilter.search = "custom";
				this.coverClassicBox.hide();
				this.coversGrid.top(115);
				break;
		}

	}

	onChoiceChanged(event)
	{
		if (!this.choicesSelect.selectedItem) return;

		this.coversGrid.scrollTop();

		this._selectTab(this.choicesSelect.selectedItem.data);
	}

	onDataUpdated(action)
	{
		if (action.impacts("theme"))
		{
			this._showGrid();
			this._selectTheme();
		}
	}

	onMore()
	{
		if(this.layoutFilter.search == "recommended")
			this.layouts.loadMore(this.data);
	}

	onDataEvent(e)
	{
		if (!this.initialized) return;
		
		switch(e.type)
		{
			// switch between cover and layout grids when user scroll to a different area.
			case "custom-layout-created" :
				if( !this.currentArea || (this.currentArea.className == "Cover"))
					this.coveNumberPhotoSelect.selectedIndex = 0;
				else
					this.numberPhotoSelect.selectedIndex = 0;
					
				this._newLayoutData = e.data;
				this.coverChoicesSelect.items = this.filterChoices;
				this.choicesSelect.items = this.filterChoices;
				//this.choicesSelect.selectedIndex = 2;
				//this.delay(this._scrollToNewLayout, 500);
				this.delay(this._selectCustomLayouts, 100);
			break;

			case "themes-loaded":
				//this.coversGrid.data = this.data.themes;
				//this.themeCoverFilter.refresh();
				this.coversGrid.forceUpdate();
				this._selectTheme();
				this.delay(this._endLoading, 500);
				break;

			
			case "theme-layouts-loaded" : 
				this._updateLayoutsGrid();
				break;

			case "theme-tag-updated":
				this.themeCoverFilter.theme_tag_id = e.data;
				this.layoutFilter.theme_tag_id = e.data;
				let theme = this.data.themes.getFirst(e.data);
				if (theme)
				{
                    if (this.book.createdfrom != "THEMES")
					    this.book.themeid = theme.id;
                    
                    this.data.theme = theme;
					this.layouts.loadThemeLayouts(this.data, theme.id, true);
				}
				
				this.coversGrid.scrollTop();
				this.layoutsGrid.scrollTop();
				this.loading(true, fx.text("Chargement"));
				break;

			/*case "theme-layouts-loaded" :
				this.delay(this._endMode, 500);
				break;*/
		}
	}

	_endLoading()
	{
		this.loading(false);
	}

	_endMode()
	{
		this.layoutsGrid.endMore();
	}

	_showGrid()
	{
		if (!this.initialized) return;

		if( this.data.zoom.value == 100 && (!this.currentArea || (this.currentArea.className == "Cover") ))
			this._switchGrid("themes");
		else /*if (this._mode != "layouts")*/
			this._switchGrid("layouts");
	}
	/****** Functions ******/

	_selectTab(tabName)
	{
		switch(tabName){
			case "recommended":
				this.layoutFilter.search = "recommended";
				this.classicBox.hide();
				this.layoutsGrid.top(115);
				break;
			case "classical":
				this.layoutFilter.search = this.numberPhotoSelect.selectedItem.value;
				this.classicBox.show();
				this.layoutsGrid.top(175);
				break;
			case "custom":
				this.layoutFilter.search = "custom";
				this.classicBox.hide();
				this.layoutsGrid.top(115);
				break;
		}
	}

	// select a theme in the covers grid
	_selectTheme()
	{
		if (!this.initialized) return;

		for(var i=0; i<this.data.themes.length; i++)
		{
			let theme = this.data.themes.getItemAt(i);
			theme.id == this.data.theme.id ? theme.selected = true : theme.selected = false;
		}

		this.layoutFilter.themeid = this.data.theme.id;
		this.layoutFilter.themes = this.data.themes;
	}

	// switch between layouts and themes grids (when user scroll)
	_switchGrid(mode)
	{
		if(mode == "themes")
		{
			if(this.data.themes)
			{
				this.layoutsPanel.hide();
				this.coversPanel.show();
				//this._mode = "cover";
			}
		}
		else if(mode == "layouts")
		{
			this._updateLayoutsGrid();
			this.coversPanel.hide();
			this.layoutsPanel.show();
			//this._mode = "layouts";
		}
	}

	// updates layouts grid data
	_updateLayoutsGrid()
	{
		this.layoutFilter.refresh();
		this.layoutsGrid.forceUpdate();
	}

	_selectCustomLayouts()
	{
		if( !this.currentArea || (this.currentArea.className == "Cover"))
		{
			let item = this.coverChoicesSelect.items.find({data:"custom"});
			this.coverChoicesSelect.selectTab(item.id);
			this.onCoverChoiceChanged();
		}
		else
		{
			let item = this.choicesSelect.items.find({data:"custom"});
			this.choicesSelect.selectTab(item.id);
			this.onChoiceChanged();
		}
		
		this.delay(this._scrollToNewLayout, 500);
	}
		
	_scrollToNewLayout()
	{
		if (this._newLayoutData)
		{
			let grid = ( !this.currentArea || (this.currentArea.className == "Cover")) ? this.coversGrid : this.layoutsGrid;

			grid.scrollToElement(this._newLayoutData);
			
			this.delay(this._applyEffectNewLayout, 500)
		}
	}

	_applyEffectNewLayout()
	{
		let grid = ( !this.currentArea || (this.currentArea.className == "Cover")) ? this.coversGrid : this.layoutsGrid;
		let element = grid.container.getChildFromData( this._newLayoutData );
		if (element)
			element.addClass("added-animation");

		this._newLayoutData = null;
	}

	// reset scroll to top
	resetScroll()
	{
		this.layoutsGrid.scrollTop();
	}
});
